<div class="container-fluid hero-bg pb-5">
  <app-header></app-header>
  <div class="container">
    <div class="row row_banner_signin justify-content-center">
      <div
        class="col-lg-11 col-md-12 col-12 mt-3"
        style="
          text-align: center;
          background-color: rgba(255, 255, 255, 1);
          border: 1px solid rgba(224, 239, 237, 1);
          border-radius: 12px;
        "
      >
        <div class="success-detail">
          <img
            src="../../assets/images/editorimages/paymentdone.svg"
            alt="donepayment"
          />
          <h1 class="">Payment Successful!</h1>
          <h4 >Thanks for subscribing!</h4>
          <p>You’ll receive a confirmation email shortly.</p>
          <button
            type="button"
            class="btn btn-dark mt-2"
            *ngIf="!notlogin && (profile_id === '1' || profile_id === null)"
            id="homepagecheckgrammar"
            [routerLink]="['/signin']"
          >
            Sign in
          </button>
          <button
            type="button"
            class="btn btn-dark mt-2"
            *ngIf="notlogin"
            id="homepagecheckgrammar"
            [routerLink]="['/openfile']"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
